import { useContext } from 'react';
import { CartContext } from '../../contexts/cart.context';
import { formatViewNumber } from '../../utils/utils';
import CheckoutItem from '../checkout-item/checkout-item.component';
import PromoCode from './promoCode.component';

export const Summary = ({
  priceWithDiscount,
  discount,
  setDiscount,
  setPromoCode,
  setFreeShipping,
  subtotal,
  deliveryPrice
}) => {
  const { cartItems } = useContext(CartContext);

  return (
    <div>
      <div className="summary-items">
        {cartItems.map((cartItem) => (
          <CheckoutItem key={cartItem.id} cartItem={cartItem} isDelivery />
        ))}
      </div>

      <PromoCode
        setDiscount={setDiscount}
        setPromoCode={setPromoCode}
        setFreeShipping={setFreeShipping}
      />

      <div className="summary-lines">
        <div className="summary-line">
          <span>Sous-total</span>
          <span>{subtotal} €</span>
        </div>

        <div className="summary-line">
          <span>Livraison</span>
          <span>{deliveryPrice} €</span>
        </div>

        {discount > 0 && (
          <div className="summary-line">
            <span>Réduction appliquée</span>
            <span>-{formatViewNumber(discount)} €</span>
          </div>
        )}
      </div>

      <div className="summary-total">
        <span className="summary-total-label">Total de la commande</span>
        <span className="summary-total-value">{priceWithDiscount} €</span>
      </div>
    </div>
  );
};

export default Summary;
